import { render, staticRenderFns } from "./TheTestBench.vue?vue&type=template&id=6ef34a50&scoped=true"
import script from "./TheTestBench.vue?vue&type=script&lang=js"
export * from "./TheTestBench.vue?vue&type=script&lang=js"
import style0 from "./TheTestBench.vue?vue&type=style&index=0&id=6ef34a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef34a50",
  null
  
)

export default component.exports